'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Mobile(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M561.895899 62.5895l-284.015565-0.192382c-11.704576 0-65.240887-0.140193-65.240887 64.309678l0.00921 759.979838c0 41.22696 35.080983 74.91727 77.954443 74.91727l442.785615 0c42.872436 0 77.95342-33.69031 77.95342-74.91727l0.01842-758.444878c0-65.844637-72.092945-65.844637-82.2247-65.844637L561.895899 62.5895zM462.103078 112.558565l99.79282 0c8.597819 0 12.483312 16.645099 12.483312 24.948205 0 8.267291-3.885494 24.985044-12.483312 24.985044l-99.79282 0c-8.595772 0-12.429077-16.71673-12.429077-24.985044C449.675024 114.143667 462.103078 112.558565 462.103078 112.558565zM512.009721 911.304312c-27.572986 0-49.888224-22.167882-49.888224-49.585325 0-27.453259 22.315238-49.584302 49.888224-49.584302 27.582195 0 49.895387 22.131043 49.895387 49.584302 0 27.417443-24.050766 49.951669-49.904597 49.951669M755.80219 774.34501 268.836353 774.34501 268.836353 212.461903l486.965837 0L755.80219 774.34501z' })
  );
}
Mobile.displayName = 'Mobile';

module.exports = Mobile;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/mobile.js
// module id = 190
// module chunks = 0